function BigBackgroundText() {
	this.build();
}

BigBackgroundText.prototype.build = function () {
	const bigBackgroundText = document.querySelector('.big-background-text');
	if (bigBackgroundText) {
		gsap.to(bigBackgroundText, {
			y: '20%',
			ease: 'none',
			scrollTrigger: {
				trigger: bigBackgroundText,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true
			}
		});
	}
};
